import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IResponseListReview } from 'entities/Review/api/types'

export class ReviewRow extends RowBase<IResponseListReview> {
  constructor(origin: IResponseListReview) {
    super(origin)
    makeObservableRowBase(this)
  }

  get name() {
    return this.origin.name
  }

  get rating() {
    return this.origin.rating
  }

  get happyCount() {
    return this.origin.happy_count
  }

  get unhappyCount() {
    return this.origin.unhappy_count
  }

  get shortUrl() {
    return this.origin.short_url
  }

  get clickCount() {
    return this.origin.click_count
  }
}
